(function () {
  "use strict";

  // Configuration
  const config = {
    cartAttributeKey: "_rf_gifting_options",
    cartUpdateUrl: "/cart/update.js",
    selectors: {
      container: ".cart-gifting-option",
      editBtn: "[data-cart-gifting-edit]",
      removeBtn: "[data-cart-gifting-remove]",
      addBtn: "[data-cart-gifting-add]",
      saveBtn: "[data-cart-gifting-save]",
      cancelBtn: "[data-cart-gifting-cancel]",
      requiredInputs: ".gifting-input[required]",
      currentOptions: ".current-gifting-options",
      editForm: "#cart-gifting-edit-form",
      addForm: "#cart-gifting-add-form"
    }
  };

  // State management
  let isInitialized = false;

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartGifting);
  } else {
    initCartGifting();
  }

  function initCartGifting() {
    if (isInitialized) {
      console.log("Cart gifting already initialized, setting up event delegation");
    } else {
      console.log("Initializing cart gifting functionality");
      isInitialized = true;
    }
    
    setupEventDelegation();
    
    // Also setup direct listeners for existing elements
    const giftingContainer = document.querySelector(config.selectors.container);
    if (giftingContainer) {
      setupFormValidation(giftingContainer);
    }
  }

  function setupEventDelegation() {
    // Use event delegation on document to handle dynamically added content
    document.addEventListener("click", handleDelegatedClick);
    document.addEventListener("blur", handleDelegatedBlur, true);
    document.addEventListener("input", handleDelegatedInput, true);
    
    // Listen for custom events that indicate content has been updated
    document.addEventListener("cartGiftingUpdated", reinitializeAfterUpdate);
    document.addEventListener("cart:updated", reinitializeAfterUpdate);
    document.addEventListener("cart:refreshed", reinitializeAfterUpdate);
  }

  function handleDelegatedClick(event) {
    const target = event.target;
    
    // Check if click is within gifting container
    if (!target.closest(config.selectors.container)) {
      return;
    }

    // Handle different button types
    if (target.matches(config.selectors.editBtn)) {
      event.preventDefault();
      showEditForm();
    } else if (target.matches(config.selectors.removeBtn)) {
      event.preventDefault();
      removeGiftOptions();
    } else if (target.matches(config.selectors.addBtn)) {
      event.preventDefault();
      addGiftOptions();
    } else if (target.matches(config.selectors.saveBtn)) {
      event.preventDefault();
      saveGiftOptions();
    } else if (target.matches(config.selectors.cancelBtn)) {
      event.preventDefault();
      cancelEdit();
    }
  }

  function handleDelegatedBlur(event) {
    const target = event?.target;
    
    if (target?.matches(config.selectors.requiredInputs) && 
        target?.closest(config.selectors.container)) {
      validateField(target);
    }
  }

  function handleDelegatedInput(event) {
    const target = event.target;
    
    if (target.matches(config.selectors.requiredInputs) && 
        target.closest(config.selectors.container)) {
      clearFieldValidation(target);
    }
  }

  function reinitializeAfterUpdate(event) {
    console.log("Reinitializing after content update");
    
    // Small delay to ensure DOM has been updated
    setTimeout(() => {
      const giftingContainer = document.querySelector(config.selectors.container);
      if (giftingContainer) {
        setupFormValidation(giftingContainer);
      }
    }, 100);
  }

  function setupFormValidation(container) {
    // This ensures any new form elements have proper attributes
    const inputs = container.querySelectorAll(config.selectors.requiredInputs);
    inputs.forEach((input) => {
      // Ensure proper attributes are set
      if (!input.hasAttribute("aria-describedby")) {
        input.setAttribute("aria-describedby", `${input.name}-error`);
      }
    });
  }

  function showEditForm() {
    const container = document.querySelector(config.selectors.container);
    if (!container) return;
    
    const currentOptions = container.querySelector(config.selectors.currentOptions);
    const editForm = container.querySelector(config.selectors.editForm);

    if (currentOptions && editForm) {
      toggleVisibility(currentOptions, false);
      toggleVisibility(editForm, true);
      
      // Pre-populate edit form with current values
      populateEditForm(container);
    }
  }

  function cancelEdit() {
    const container = document.querySelector(config.selectors.container);
    if (!container) return;
    
    const currentOptions = container.querySelector(config.selectors.currentOptions);
    const editForm = container.querySelector(config.selectors.editForm);

    if (currentOptions && editForm) {
      toggleVisibility(currentOptions, true);
      toggleVisibility(editForm, false);
      
      // Clear any validation errors
      clearFormValidation(editForm);
    }
  }

  function toggleVisibility(element, show) {
    if (!element) return;
    
    element.style.display = show ? "block" : "none";
    element.setAttribute("aria-hidden", show ? "false" : "true");
  }

  function populateEditForm(container) {
    try {
      const giftingData = window._rf_gifting_options ? JSON.parse(window._rf_gifting_options) : null;
      if (!giftingData) return;

      const editForm = container.querySelector(config.selectors.editForm);
      if (!editForm) return;

      // Populate form fields
      const nameField = editForm.querySelector('input[name="cart_recipient_name"]');
      const emailField = editForm.querySelector('input[name="cart_recipient_email"]');
      const messageField = editForm.querySelector('textarea[name="cart_gift_message"]');

      if (nameField) nameField.value = giftingData.name || "";
      if (emailField) emailField.value = giftingData.email || "";
      if (messageField) messageField.value = giftingData.message || "";
    } catch (error) {
      console.warn("Error populating edit form:", error);
    }
  }

  function addGiftOptions() {
    const form = document.querySelector(config.selectors.addForm);
    if (!form) return;

    const formData = collectFormData(form);
    if (!validateFormData(formData, form)) return;

    saveGiftingData(formData);
  }

  function saveGiftOptions() {
    const form = document.querySelector(config.selectors.editForm);
    if (!form) return;

    const formData = collectFormData(form);
    if (!validateFormData(formData, form)) return;

    saveGiftingData(formData);
  }

  async function removeGiftOptions() {
    if (!confirm("Are you sure you want to remove gift options?")) return;

    const attributeData = {
      attributes: {
        [config.cartAttributeKey]: null,
      },
    };

    try {
      showLoading(true);

      const response = await fetch(config.cartUpdateUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(attributeData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Gift options removed successfully", data);

      // Update global variable
      window._rf_gifting_options = "";

      // Update UI to reflect removal
      updateGiftingUI("removed");

      // Clear all forms
      clearAllForms();

      // Show success message
      showSuccessMessage("Gift options removed successfully!");

      // Refresh cart without page reload
      await refreshCartContents();
      
      // Emit removal event
      emitEvent("giftingOptionsRemoved", { data });

    } catch (error) {
      console.error("Error removing gift options:", error);
      showErrorMessage("Error removing gift options. Please try again.");
    } finally {
      showLoading(false);
    }
  }

  function collectFormData(form) {
    const nameField = form.querySelector('input[name="cart_recipient_name"]');
    const emailField = form.querySelector('input[name="cart_recipient_email"]');
    const messageField = form.querySelector('textarea[name="cart_gift_message"]');

    return {
      name: nameField ? nameField.value.trim() : "",
      email: emailField ? emailField.value.trim() : "",
      message: messageField ? messageField.value.trim() : "",
      credit: 0, // Default credit value
    };
  }

  function validateFormData(data, form) {
    let isValid = true;
    const errors = [];

    // Validate required fields within the specific form
    const nameField = form.querySelector('input[name="cart_recipient_name"]');
    const emailField = form.querySelector('input[name="cart_recipient_email"]');

    if (!data.name) {
      if (nameField && !validateField(nameField)) {
        errors.push("Recipient name is required");
        isValid = false;
      }
    }

    if (!data.email || !isValidEmail(data.email)) {
      if (emailField && !validateField(emailField)) {
        errors.push("Valid recipient email is required");
        isValid = false;
      }
    }

    if (!isValid) {
      console.warn("Form validation failed:", errors);
      
      // Focus on first invalid field
      const firstInvalidField = form.querySelector('.gifting-field-error');
      if (firstInvalidField) {
        firstInvalidField.focus();
      }
    }

    return isValid;
  }

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function validateField(field) {
    const value = field.value.trim();
    const isEmail = field.type === "email";
    const isValid = value.length > 0 && (!isEmail || isValidEmail(value));

    if (!isValid) {
      field.classList.add("gifting-field-error");
      field.setAttribute("aria-invalid", "true");
    } else {
      clearFieldValidation(field);
    }

    return isValid;
  }

  function clearFieldValidation(field) {
    field.classList.remove("gifting-field-error");
    field.removeAttribute("aria-invalid");
    
    // Also remove any error messages
    const errorElement = document.getElementById(`${field.name}-error`);
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.style.display = "none";
    }
  }

  function clearFormValidation(form) {
    const fields = form.querySelectorAll('.gifting-field-error');
    fields.forEach(clearFieldValidation);
  }

  async function saveGiftingData(formData) {
    const giftingData = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      credit: formData.credit || 0,
    };

    const jsonData = JSON.stringify(giftingData);
    const attributeData = {
      attributes: {
        [config.cartAttributeKey]: jsonData,
      },
    };

    try {
      showLoading(true);
      
      const response = await fetch(config.cartUpdateUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(attributeData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Gift options saved successfully", data);

      // Update global variable
      window._rf_gifting_options = jsonData;

      // Update UI to reflect changes
      updateGiftingUI("saved", giftingData);

      // Clear forms
      clearAllForms();

      // Show success message
      showSuccessMessage("Gift options saved successfully!");

      // Refresh cart without page reload
      await refreshCartContents();
      
      // Emit success event
      emitEvent("giftingOptionsSaved", { data: giftingData });

    } catch (error) {
      console.error("Error saving gift options:", error);
      showErrorMessage("Error saving gift options. Please try again.");
    } finally {
      showLoading(false);
    }
  }

  function showLoading(show) {
    const buttons = document.querySelectorAll(".gifting-btn-cart");
    buttons.forEach((btn) => {
      btn.disabled = show;
      if (show) {
        btn.style.opacity = "0.6";
        btn.style.cursor = "not-allowed";
        // Add loading text if it's a primary action button
        if (btn.classList.contains("gifting-btn-cart--primary") || btn.classList.contains("gifting-btn-cart--remove")) {
          btn.setAttribute("data-original-text", btn.textContent);
          btn.textContent = btn.classList.contains("gifting-btn-cart--remove") ? "Removing..." : "Saving...";
        }
      } else {
        btn.style.opacity = "";
        btn.style.cursor = "";
        // Restore original text
        const originalText = btn.getAttribute("data-original-text");
        if (originalText) {
          btn.textContent = originalText;
          btn.removeAttribute("data-original-text");
        }
      }
    });
  }

  // Update gifting UI without page reload
  function updateGiftingUI(action, giftingData = null) {
    const container = document.querySelector(config.selectors.container);
    if (!container) return;

    if (action === "saved" && giftingData) {
      // Update the display with new gifting data
      updateGiftingDisplay(giftingData);

      // Hide forms and show current options
      const currentOptions = container.querySelector(config.selectors.currentOptions);
      const addForm = container.querySelector(config.selectors.addForm);
      const editForm = container.querySelector(config.selectors.editForm);

      if (addForm) toggleVisibility(addForm, false);
      if (editForm) toggleVisibility(editForm, false);
      if (currentOptions) toggleVisibility(currentOptions, true);
      
    } else if (action === "removed") {
      // Switch back to add form
      const currentOptions = container.querySelector(config.selectors.currentOptions);
      const addForm = container.querySelector(config.selectors.addForm);
      const editForm = container.querySelector(config.selectors.editForm);

      if (currentOptions) toggleVisibility(currentOptions, false);
      if (editForm) toggleVisibility(editForm, false);
      if (addForm) toggleVisibility(addForm, true);

      // Update gifting status indicator
      const statusIndicator = container.querySelector(".gifting-status-indicator");
      if (statusIndicator) {
        statusIndicator.style.display = "none";
      }
    }
    
    // Re-setup form validation after UI update
    setupFormValidation(container);
  }

  function updateGiftingDisplay(giftingData) {
    const container = document.querySelector(".cart-gifting-option");
    if (!container) return;

    // Update recipient name
    const nameDisplay = container.querySelector(".gifting-summary p:nth-child(2)");
    if (nameDisplay && giftingData.name) {
      nameDisplay.innerHTML = `<strong>Recipient:</strong> ${giftingData.name}`;
    }

    // Update recipient email
    const emailDisplay = container.querySelector(".gifting-summary p:nth-child(3)");
    if (emailDisplay && giftingData.email) {
      emailDisplay.innerHTML = `<strong>Email:</strong> ${giftingData.email}`;
    }

    // Update message
    const messageDisplay = container.querySelector(".gifting-summary p:nth-child(4)");
    if (messageDisplay && giftingData.message) {
      const truncatedMessage =
        giftingData.message.length > 100 ? giftingData.message.substring(0, 100) + "..." : giftingData.message;
      messageDisplay.innerHTML = `<strong>Message:</strong> ${truncatedMessage}`;
    }

    // Show status indicator
    const statusIndicator = container.querySelector(".gifting-status-indicator");
    if (statusIndicator) {
      statusIndicator.style.display = "inline";
    }
  }

  function clearForm(form) {
    if (!form) return;
    
    const inputs = form.querySelectorAll("input, textarea");
    inputs.forEach((input) => {
      input.value = "";
      clearFieldValidation(input);
    });
  }

  function clearAddForm() {
    const addForm = document.querySelector(config.selectors.addForm);
    clearForm(addForm);
  }

  function clearAllForms() {
    const container = document.querySelector(config.selectors.container);
    if (!container) return;
    
    const addForm = container.querySelector(config.selectors.addForm);
    const editForm = container.querySelector(config.selectors.editForm);
    
    clearForm(addForm);
    clearForm(editForm);
  }

  // Refresh cart contents without page reload
  async function refreshCartContents() {
    try {
      // Try different refresh methods in order of preference
      if (typeof window.refreshCart === "function") {
        // Use the existing refreshCart function from add-to-cart-custom.js
        await window.refreshCart();
        emitEvent("cartGiftingUpdated", { source: "window.refreshCart" });
        
      } else if (typeof refreshCartDrawer === "function") {
        // Fallback to refreshCartDrawer if available
        await refreshCartDrawer();
        emitEvent("cartGiftingUpdated", { source: "refreshCartDrawer" });
        
      } else {
        // Manually refresh cart sections
        const response = await fetch("/?sections=cart-drawer,cart-counter", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();
        console.log("Refreshing cart sections:", json);

        // Update cart drawer if available
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.renderContents({ sections: json }, true, false);
        }

        // Update cart counter
        const cartDrawerCounter = document.querySelector(".cart-drawer__title-counter");
        if (cartDrawerCounter && json["cart-counter"]) {
          // Extract counter from cart-counter section if available
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = json["cart-counter"];
          const newCounter = tempDiv.querySelector(".cart-drawer__title-counter");
          if (newCounter) {
            cartDrawerCounter.innerHTML = newCounter.innerHTML;
          }
        }

        // Emit event for other components to listen
        emitEvent("cartGiftingUpdated", { sections: json, source: "manual" });
      }
      
    } catch (error) {
      console.error("Error refreshing cart:", error);
      // Emit error event before falling back to reload
      emitEvent("cartGiftingError", { error: error.message });
      
      // Only reload as last resort
      if (confirm("There was an error updating the cart. Would you like to refresh the page?")) {
        window.location.reload();
      }
    }
  }

  function showNotificationMessage(message, type = "info") {
    // Try to use existing notification system first
    if (window.showNotification && typeof window.showNotification === "function") {
      window.showNotification(message, type);
      return;
    }

    // Create a temporary notification element
    const notification = createNotificationElement(message, type);
    document.body.appendChild(notification);

    // Animate in
    setTimeout(() => {
      notification.style.transform = "translateX(0)";
      notification.style.opacity = "1";
    }, 10);

    // Remove after delay
    const delay = type === "error" ? 5000 : 3000;
    setTimeout(() => {
      removeNotification(notification);
    }, delay);
  }

  function createNotificationElement(message, type) {
    const colors = {
      success: "#4CAF50",
      error: "#ff6b6b",
      info: "#2196F3",
      warning: "#ff9800"
    };

    const notification = document.createElement("div");
    notification.className = `gifting-notification gifting-notification--${type}`;
    notification.setAttribute("role", "alert");
    notification.setAttribute("aria-live", "polite");
    
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${colors[type] || colors.info};
      color: white;
      padding: 15px 20px;
      border-radius: 5px;
      z-index: 10000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      font-size: 14px;
      max-width: 320px;
      transform: translateX(100%);
      opacity: 0;
      transition: all 0.3s ease;
      font-family: inherit;
      line-height: 1.4;
    `;
    
    notification.textContent = message;
    return notification;
  }

  function removeNotification(notification) {
    if (!notification || !notification.parentNode) return;
    
    notification.style.transform = "translateX(100%)";
    notification.style.opacity = "0";
    
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }

  function showErrorMessage(message) {
    showNotificationMessage(message, "error");
  }

  function showSuccessMessage(message) {
    showNotificationMessage(message, "success");
  }

  // Emit custom events for integration
  function emitEvent(eventName, detail = {}) {
    const event = new CustomEvent(eventName, {
      detail: {
        ...detail,
        timestamp: Date.now(),
        source: "gifting-modal-cart"
      },
      bubbles: true,
      cancelable: true,
    });
    
    console.log(`Emitting event: ${eventName}`, detail);
    document.dispatchEvent(event);
  }

  // Public API - expose methods that might be needed by other scripts
  window.GiftingCart = {
    init: initCartGifting,
    refresh: () => {
      const container = document.querySelector(config.selectors.container);
      if (container) {
        setupFormValidation(container);
      }
    },
    clear: clearAllForms,
    showMessage: showNotificationMessage
  };

  // Re-initialize on page navigation (for SPA-like behavior)
  if (window.history && window.history.pushState) {
    const originalPushState = window.history.pushState;
    window.history.pushState = function(...args) {
      originalPushState.apply(window.history, args);
      setTimeout(initCartGifting, 100);
    };
  }

})();
